import React, { useEffect } from "react";
import "../popup.css";
import SubmitButton from "../../Buttons/SubmitButton";
import CancelButton from "../../Buttons/CancelButton";
import ExternalLink from "../../ExternalLink/ExternalLink.tsx";
import { gtmPush } from "../../../analytics/useGtmPageview.tsx";

const DuplicateorStopWarningModel = ({
  onContinue,
  onCancel,
  onClose,
  showDuplicate,
}) => {
  const handleOverlayClick = (e) => {
    // Only trigger cancel if user clicks directly on the overlay
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  useEffect(() => {
        gtmPush("popup_open", {
            popup_id: "identity_already_exists",
            popup_name: "Identity Already Exists",
            trigger: "auto",
            page_path: window.location.pathname + window.location.search,
          });
  }, []);

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content">
        {showDuplicate ? (
          <>
            <h1 className="modal-title">
              It looks like you already have a <br /> verified identity.
            </h1>

            <p className="modal-text">
              If you continue, we'll merge your existing verified identity with
              this application.
            </p>

            <p className="modal-text">
              Your verified identity can only be linked to one log-in at a time
              — so you'll need to use your new log-in for your verified
              identity.
            </p>

            <p className="modal-text">
              <ExternalLink
                href="https://www.realme.govt.nz/contact-us/"
                text="Contact us if you need help"
              />
            </p>

            <div className="modal-actions">
              <SubmitButton text={"Continue"} onClick={onContinue} />
              <CancelButton text={"Cancel application"} onClick={onCancel} />
            </div>
          </>
        ) : (
          <>
            <h1 className="modal-title">
              You cannot apply for a new <br /> verified identity.
            </h1>

            <p className="modal-text">
              This may be because you already have a verified identity that has
              been revoked or suspended.
            </p>

            <p className="modal-text">
              <ExternalLink
                href="https://www.realme.govt.nz/contact-us/"
                text="Contact us if you need help"
              />
            </p>

            <div className="modal-actions">
              <CancelButton text={"Cancel application"} onClick={onCancel} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DuplicateorStopWarningModel;
